<template>
    <v-dialog :value="exibirModal && requisicaoEditar" persistent :max-width="'600'">
        <v-card>
            <v-card-title class="primary modal-title" primary-title>
                <span>
                    Alterar Pre Request Delegate
                </span>
            </v-card-title>
            <v-card-text v-if="requisicaoEditar">
                <span>
                    Escreva um novo pre request delegate para a requisição {{requisicaoEditar.id}}:
                </span>

                <br>
                <br>

                <v-text-field label="Pre Request Delegate" :name="'Pre Request Delegate' + requisicaoEditar.id"
                              :key="'Pre-Request-Delegate' + requisicaoEditar.id"
                              placeholder="Ex. br.com.azi.compradireta.InserirCompraUseCase"
                              :error-messages="errors.collect('Pre Request Delegate' + requisicaoEditar.id)"
                              v-model="preRequestDelegate" v-validate="''" maxlength="500" :counter="500"/>

            </v-card-text>

            <v-card-actions>
                <v-flex>
                    <div class="lista-opcoes__acao">
                        <az-call-to-action id="botaoConfirmar"
                                           @click="$emit('cancelar')"
                                           css-class="botao" class="ma-2 py-2"
                                           slot="actions">
                            Cancelar
                        </az-call-to-action>
                        <az-call-to-action id="botaoFechar"
                                           @click="confirmar()"
                                           css-class="botao-desativado" class="ma-2 py-2"
                                           slot="actions">
                            Confirmar
                        </az-call-to-action>
                    </div>
                </v-flex>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: 'ModalEditarResponseDelegateRequisicao',
    props: {
        exibirModal:{
            type: Boolean,
            default: false
        },
        requisicaoEditar:{
            type: Object,
            default: null,
        }
    },
    data(){
        return{
            preRequestDelegate: null
        }
    },
    mounted(){
        this.preRequestDelegate = this.requisicaoEditar.preRequestDelegate
    },
    methods:{
        confirmar() {
            this.requisicaoEditar.preRequestDelegate = this.preRequestDelegate
            this.$emit('confirmar', this.requisicaoEditar)
        }
    }
}
</script>

<style scoped lang="stylus">
    .lista-opcoes
        text-align center

        &__acao
            display flex
            justify-content space-between
            text-align center

    .botao-desativado
        color #777 !important

</style>
